var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeadlines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5D67C4",
    d: "M44.152 32.606c-6.036 0-10.946 4.91-10.946 10.947 0 6.037 4.91 10.947 10.946 10.947S55.1 49.59 55.1 43.553c0-6.037-4.91-10.947-10.947-10.947Zm5.066 11.717h-5.114a.716.716 0 0 1-.716-.716v-8.183a.716.716 0 1 1 1.432 0v7.467h4.4a.715.715 0 1 1-.002 1.432Zm-6.769-33.08h-3.224V2.5h3.224v8.743Zm-15.24 0h-3.224V2.5h3.224v8.743Zm-15.239 0H8.747V2.5h3.223v8.743Zm19.357 32.234c0-7.073 5.734-12.807 12.807-12.807 2.083 0 4.049.501 5.788 1.384V11.67c0-.967-.792-1.758-1.758-1.758h-4.03a3.297 3.297 0 0 1-6.594 0h-8.645a3.297 3.297 0 0 1-6.595 0h-8.645a3.297 3.297 0 0 1-6.593 0h-4.03c-.968 0-1.759.792-1.759 1.758v38.025c0 .967.792 1.758 1.759 1.758h31.086a12.749 12.749 0 0 1-2.79-7.976Zm4.694-23.54h9.011v9.012h-9.011v-9.012ZM15.175 43.968H6.164v-9.012h9.011v9.012Zm0-15.02H6.164v-9.01h9.011v9.01Zm14.928 15.02h-9.01v-9.012h9.01v9.012Zm0-15.02h-9.01v-9.01h9.01v9.01Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    d: "M44.207 32.606c-6.036 0-10.947 4.91-10.947 10.947 0 6.037 4.911 10.947 10.947 10.947s10.947-4.91 10.947-10.947c0-6.037-4.91-10.947-10.947-10.947Zm5.066 11.717H44.16a.715.715 0 0 1-.716-.716v-8.183a.715.715 0 1 1 1.432 0v7.467h4.399a.715.715 0 1 1 0 1.432Zm-6.77-33.08H39.28V2.5h3.224v8.743Zm-15.239 0H24.04V2.5h3.224v8.743Zm-15.239 0H8.801V2.5h3.224v8.743Zm19.357 32.234c0-7.073 5.734-12.807 12.806-12.807 2.084 0 4.05.501 5.788 1.384V11.67c0-.967-.791-1.758-1.758-1.758h-4.03a3.297 3.297 0 0 1-6.593 0h-8.646a3.297 3.297 0 0 1-6.594 0H13.71a3.297 3.297 0 0 1-6.594 0h-4.03c-.967 0-1.758.792-1.758 1.758v38.025c0 .967.792 1.758 1.758 1.758h31.087a12.749 12.749 0 0 1-2.791-7.976Zm4.693-23.54h9.012v9.012h-9.012v-9.012ZM15.23 43.968H6.218v-9.012h9.012v9.012Zm0-15.02H6.218v-9.01h9.012v9.01Zm14.928 15.02h-9.011v-9.012h9.011v9.012Zm0-15.02h-9.011v-9.01h9.011v9.01Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.673,
    height: 22.673,
    x: 33.039,
    y: 31.783,
    fill: "#fff",
    rx: 11.337
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadlines);
export default __webpack_public_path__ + "static/media/deadlines.7caa8207677f41adced13a087c295c55.svg";
export { ForwardRef as ReactComponent };